<template>
  <SliderBox
    class="statistics-slider"
    ref="sliderBox"
    orientation="vertical"
    :swipe-enabled="isDesktop"
    :autoplay="isDesktop"
    :autoplay-interval="10000"
  >
    <OrdersSlide @update-slider="updateSlider" />
    <PartnersSlide v-if="isPartnerSlideVisible" @update-slider="updateSlider" />
    <InsuranceCompaniesSlide @update-slider="updateSlider" />
    <ProductsSlide @update-slider="updateSlider" />
  </SliderBox>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import InsuranceCompaniesSlide from '../insurance-companies-slide';
import OrdersSlide from '../orders-slide';
import PartnersSlide from '../partners-slide';
import ProductsSlide from '../products-slide';
import { SLIDER_EVENTS, SliderBox } from '@/shared/ui/slider';

export  default {
  created() {
    this.fetchPartners();
  },
  components: { SliderBox, OrdersSlide, PartnersSlide, InsuranceCompaniesSlide, ProductsSlide },
  computed: {
    ...mapGetters('currentUserModule', ['isMainPartner', 'isBankPartner']),
    ...mapGetters('layoutModule', ['isDesktop', 'isTablet']),
    isPartnerSlideVisible() {
      return this.isMainPartner || this.isBankPartner;
    },
  },
  methods: {
    ...mapActions('partnersListModule', ['fetchPartners']),
    updateSlider(delay = 0) {
      this.$eventBus.$emit(SLIDER_EVENTS.UPDATE, { id: this.$refs.sliderBox.getSliderId, delay });
    },
  },
  watch: {
    isPartnerSlideVisible: {
      immediate: false,
      handler() {
        this.updateSlider();
      }
    },
    isDesktop: {
      immediate: false,
      handler(isDesktop) {
        if (isDesktop) {
          this.updateSlider();
        }
      }
    },
    isTablet: {
      immediate: false,
      handler(isTablet) {
        if (isTablet) {
          this.updateSlider();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.statistics-slider {
  height: auto;
  border: 1px solid #CBD5E1;
  border-radius: 8px;
  margin-bottom: 25px;
  box-shadow: 0px 1px 2px 0px #0000000F, 0px 1px 3px 0px #0000001A;
}
</style>
